import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import { DonutChartModule, getDonutData, IconModule } from '@hglobal/common';
import { TransactionChart, TransactionChartType } from '@pt/models';
import { CoinComponent } from '@pt/components';

import { COLORS } from './models';

@Component({
  selector: 'pt-transaction-donut-total',
  templateUrl: './transaction-donut-total.component.html',
  styleUrls: ['./transaction-donut-total.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DonutChartModule, IconModule, TranslateModule, CoinComponent],
})
export class TransactionDonutTotalComponent {
  chart = input.required<TransactionChart>();

  readonly colors = computed(() => COLORS[this.chart().id]);

  readonly donutData = computed(() => {
    const { metrics } = this.chart();
    return getDonutData(...metrics.map((metric, i) => [
      metric.amount, this.colors()[i],
    ] as [number, string]));
  });

  readonly gap = computed(() => {
    const { metrics } = this.chart();
    const hasGap = metrics.reduce((acc, metric) => (metric.amount > 0 ? acc + 1 : acc), 0) > 1;
    return hasGap ? 4 : 0;
  });

  readonly hasSum = computed(() => {
    return [TransactionChartType.Income, TransactionChartType.Expense].includes(this.chart().id);
  });
}
